import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Input,
  FormGroup,
  Label,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  Card,
  CardBody,
} from "reactstrap";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import { Formik, Field } from "formik";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import Confirm from "components/Confirm";
import PharmacyList from "components/PharmacyList";
import Calendar from "assets/icon/calendar-icon.svg";
import { dateFormate } from "utils/columns";
import Add from "assets/icon/AddWhite.svg";
import save from "assets/icon/save.svg";

let hasDatePopupOpen = false;
const CEContract = ({ selectedCoveredEntity, toggle, module, refetch }) => {
  const { coveredEntityID, coveredEntityName, tenant } = selectedCoveredEntity;
  const API = useAxios();
  const [isConfirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tpaData, setTpaData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [selectedPharmacy, setSelectedPharmacy] = useState(null);
  const [pharmacyList, setPharmacyList] = useState([]);
  const [tpaID, setTpa] = useState(0);
  const [saveDisabled, setSaveDisabled] = useState(true);
  //const [addDisabled, setAddDisabled] = useState(true);
  const [hideRow, setHideRow] = useState(false);
  const [showResultRow, setShowResultRow] = useState(true);
  const [resultData, setResultData] = useState([]);

  const formikRef = useRef();

  useEffect(() => {
    getTPA();
  }, []);

  const getTPA = async () => {
    try {
      setLoading(true);
      const { data } = await API.get(`Config/ThirdPartyAdmin/list`, {
        hideLoader: true,
      });
      if (data) {
        setTpaData(data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleStartDate = (startDate) => {
    let stDate = dateFormate(startDate);
    setStartDate(stDate);
    //handleAddDisabled(stDate);
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  let addDisabled =
    selectedPharmacy != null && startDate != null ? false : true;

  // const handleAddDisabled = (stDate) => {
  //     ;
  //     if (selectedPharmacy != null && startDate != null) {
  //         setAddDisabled(false);
  //     }
  //     else {
  //         setAddDisabled(true);
  //     }
  // };

  const handleSelectPharmacy = (pharmacy) => {
    setSelectedPharmacy(pharmacy);
    //handleAddDisabled();
  };

  const handleSubmit = async () => {
    handleSaveConfirmation();
    setLoading(true);
    let payload = {};
    payload.thirdAdminID = tpaID;
    payload.converedEntityID = coveredEntityID;
    payload.contractPharmacyModel = pharmacyList;
    try {
      const result = await API.post(
        `Config/ceconfig/addcecontract/${coveredEntityID}`,
        payload
      );
      if (result) {
        console.log(result, "result");
        // refetch();
        // toggle();
        if (result?.data[0].success == true) {
          toast.success("CE contract saved successfully");
        }
        setResultData(result.data);
        setHideRow(true);
        setShowResultRow(false);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

    setLoading(false);
  };

  const handleSaveConfirmation = () => {
    setConfirm(!isConfirm);
  };

  const handleReset = () => {
    setStartDate(null);
    setSelectedPharmacy(null);
  };
  const handlePharmacyAdd = () => {
    var lst = {};
    lst.pharmacyID = selectedPharmacy.pharmacyID;
    lst.pharmacyName = selectedPharmacy.pharmacyName;
    lst.startDate = startDate;
    if (pharmacyList.length > 0) {
      let pCheck = pharmacyList.filter((m) => m.pharmacyID == lst.pharmacyID);
      if (pCheck.length == 0) {
        setPharmacyList((old) => [...old, lst]);
      } else {
        toast.error("Duplicate entry not allowed.");
      }
    } else {
      setPharmacyList((old) => [...old, lst]);
    }
    handleReset();
    handleSaveDisabled(undefined, lst);
  };

  const handleChange = (e) => {
    setTpa(e.target.value);
    handleSaveDisabled(e.target.value, undefined);
  };

  const handleSaveDisabled = (tp, lst) => {
    if (tp === "") {
      setSaveDisabled(true);
    } else if (
      (parseInt(tp) > 0 || parseInt(tpaID) > 0) &&
      (pharmacyList.length > 0 || lst !== undefined)
    ) {
      setSaveDisabled(false);
    } else {
      setSaveDisabled(true);
    }
  };

  return (
    <div>
      <Formik
        onSubmit={handleSubmit}
        enableReinitialize={true}
        innerRef={formikRef}
        children={(props) => {
          return (
            <div>
              <Card className="border-0 shadow-top borders">
                <CardBody className="section-devider-border">
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="coveredEntity" className="headings">
                          Covered Entity
                        </Label>
                        <div>
                          <p className="d-inline-block font-weight-500 f-14">
                            {`${coveredEntityName || "-"} `}
                          </p>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="tenant" className="headings">
                          Tenant
                        </Label>
                        <div>
                          <p className="d-inline-block font-weight-500 f-14">
                            {`${tenant || "-"} `}
                          </p>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={4} hidden={hideRow}>
                      <FormGroup>
                        <Label for="tpa">Third Party Admin</Label>
                        <Input
                          id="tpaID"
                          name="tpaID"
                          type="select"
                          onChange={(e) => handleChange(e)}
                        >
                          <option value={""}>--Select--</option>
                          {tpaData.map((status) => {
                            const { thirdPartyAdminID, thirdPartyAdminName } =
                              status;
                            return (
                              <option
                                key={thirdPartyAdminID}
                                value={thirdPartyAdminID}
                              >
                                {thirdPartyAdminName}
                              </option>
                            );
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={4} hidden={hideRow}>
                      <Label for="pharmacy">Pharmacy</Label>
                      <PharmacyList
                        onSelect={handleSelectPharmacy}
                        selectedPharmacy={selectedPharmacy}
                      />
                    </Col>
                    <Col md={4} hidden={hideRow}>
                      <FormGroup>
                        <Label>Start Date</Label>
                        <InputGroup onMouseLeave={handleMouseLeave}>
                          <Field
                            type="text"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            placeholder="Select a date"
                            value={startDate}
                            component={FormikDatePicker}
                            onChange={handleStartDate}
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("startDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row
                    hidden={hideRow}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Col md={"auto"}>
                      <Label>&nbsp;</Label>
                      <Button
                        color="primary"
                        className="search"
                        onClick={handlePharmacyAdd}
                        // style={{ float: "right" }}
                        disabled={addDisabled}
                      >
                        <span className="right_5">
                          <img src={Add} alt="" />
                        </span>{" "}
                        Add
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <div
                className="border-0 mt-3"
                hidden={hideRow}
              >
                <div className="section-devider-border">
                  <Row>
                    <Col>
                      <div className="table-card scroll-table position-relative border-0 rounded pt-0">
                        <div className="rounded-table">
                          <div className="table-responsive">
                            <table
                              id="reactstrap-table"
                              className="table table-striped theme-table undefined table"
                            >
                              <thead>
                                <tr>
                                  <th width="144">Pharmacy Name</th>
                                  <th width="144">Start Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pharmacyList.map((item, index) => (
                                  <tr key={item.pharmacyID}>
                                    <td>{item.pharmacyName}</td>
                                    <td>{item.startDate}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              <Row
                hidden={hideRow}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "10px",
                }}
              >
                <Col>
                  <Button
                    color="primary"
                    className="search"
                    onClick={handleSaveConfirmation}
                    style={{ float: "right" }}
                    disabled={saveDisabled}
                  >
                    <span className="right_5">
                      <img src={save} alt="" />
                    </span>{" "}
                    Save
                  </Button>
                </Col>
              </Row>
              <Card
                className="border-0 shadow-top mt-3 borders"
                hidden={showResultRow}
              >
                <CardBody className="section-devider-border">
                  <Row>
                    <Col>
                      <div className="table-card scroll-table position-relative border-0 rounded pt-0">
                        <div className="rounded-table">
                          <div className="table-responsive">
                            <table
                              id="reactstrap-table"
                              className="table table-striped theme-table undefined table"
                            >
                              <thead>
                                <tr>
                                  <th>Status</th>
                                  <th width="144">Pharmacy Name</th>
                                  <th width="144">Start Date</th>
                                  <th>Message</th>
                                </tr>
                              </thead>
                              <tbody>
                                {resultData.map((item, index) => (
                                  <tr key={item.pharmacyID}>
                                    <td>
                                      {item.success == true && "Success"}
                                      {item.success == false && "Error"}
                                    </td>
                                    <td>{item.pharmacyName}</td>
                                    <td>{dateFormate(item.startDate)}</td>
                                    <td>{item.message}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          );
        }}
      ></Formik>
      <Confirm
        isOpen={isConfirm}
        loading={loading}
        message="Are you sure you want to save?"
        onToggle={handleSaveConfirmation}
        onCancel={handleSaveConfirmation}
        onContinue={handleSubmit}
      />
    </div>
  );
};

export default CEContract;
